import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento_tatico', 'planejamento-tatico-arquivo/{idPlanejamento}');

const planejamentoActions = {
  listar: { method: 'GET', url: `${basePath}` },
  registrarArquivo: { method: 'POST', url: `${basePath}/salvar` },
};

export default resource => resource(`${basePath}`, {}, planejamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/planejamento-tatico-arquivo.js